import { cloneElement, forwardRef } from 'react';
import { DisclosureExpand, DisclosureNext } from '@sas/react-svg';
// Import CSS last
import cx from 'classnames';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { Icon } from '../Icon';
import { Label } from '../Label';
import cn from './TreeTableNode.css.json';
import './TreeTableNode.css';
import bundle from './NovaComponents-TreeTable-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const TreeTableNode = /*#__PURE__*/forwardRef((props, ref) => {
  function onArrowClick(e) {
    e.stopPropagation();
    if (props.onArrowClick) props.onArrowClick(props.node.id);
  }
  const localize = useTextLocalizer();
  const dt = useDesignTokens();
  const nodeLabelStyle = renderInlineCssVars({
    'label-fg': props.disabled ? 'var(--tree-disabled-fg)' : 'var(--tree-fg)',
    'label-text-cursor': props.disabled ? 'default' : 'pointer'
  });
  const hasChildren = props.hasChildren || Array.isArray(props.node.children) && props.node.children.length > 0;
  return /*#__PURE__*/_jsxs("div", {
    className: cn.item,
    "data-testid": props.testId,
    children: [hasChildren ? /*#__PURE__*/_jsx(Icon, {
      tabIndex: -1,
      role: "img",
      disabled: props.expandCollapseDisabled || props.disabled,
      ariaHidden: true,
      ariaLabel: props.expanded ? localize('expanded.msg') : localize('collapsed.msg'),
      onClick: onArrowClick,
      className: cx(cn.expandIcon, props.expandCollapseDisabled === false && props.disabled === false ? cn.expandIconCursorPointer : undefined),
      icon: props.expanded ? DisclosureExpand : DisclosureNext,
      testId: 'expandIcon',
      theme: () => ({
        '--icon-default-override-fg': props.expandCollapseDisabled || props.disabled ? dt.tokens['color-action-icon-subtle-disabled'] : 'var(--tree-fg)'
      })
    }) : null, props.selectionControl, props.node.icon ? /*#__PURE__*/_jsx(Icon, {
      className: cn.nodeIcon,
      disabled: props.disabled,
      ...('icon' in props.node.icon ? {
        ...props.node.icon
      } : {
        icon: props.node.icon
      })
    }) : null, props.nodeElement ? /*#__PURE__*/cloneElement(props.nodeElement, {
      ref,
      id: props.labelId
    }) : /*#__PURE__*/_jsx(Label, {
      required: !!props.node.required,
      wrapText: false,
      className: cn.nodeLabel,
      style: {
        ...nodeLabelStyle,
        width: '100%'
      },
      disabled: props.disabled,
      suppressTooltip: props.suppressTooltip,
      id: props.labelId,
      children: props.node.text
    })]
  });
});
//# sourceMappingURL=TreeTableNode.js.map